import { setContext } from "@apollo/client/link/context";
import { fetchAuthSession } from "aws-amplify/auth";

export default setContext(async (_, { headers }) => {
  const session = await fetchAuthSession();
  const token =
    session.tokens?.idToken?.toString() ??
    session.tokens?.accessToken?.toString();

  return {
    headers: {
      ...headers,
      ...(token ? { authorization: token } : {}),
    },
  };
});
